import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { Preview } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                        console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail Hukuman</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Hukuman
                                    </CardSubtitle>
                                    <hr />

                                      <Row className="mb-3">
                                        <label className="col-md-3">
                                            Hukuman Disiplin
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_long_name !== "" ? this.state.detail.punishment_long_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                           NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_nip !== "" ? this.state.detail.punishment_nip : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Lengkap
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_name !== "" ? this.state.detail.punishment_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                            Posisi
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_position !== "" ? this.state.detail.punishment_position : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                            Unit Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_work_unit !== "" ? this.state.detail.punishment_work_unit : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                           Keterangan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_description !== "" ? this.state.detail.punishment_description : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            No SK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_sk_number !== "" ? this.state.detail.punishment_sk_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal SK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_sk_date !== "" ? this.state.detail.punishment_sk_date : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal TMT SK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.punishment_sk_tmt_date !== "" ? this.state.detail.punishment_sk_tmt_date : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                         File SK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.documents_path !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.detail.documents_path}>
                                                        <i className="uil-file-download"></i> 
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                   
                                   

                                   
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/hukuman.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);